import { apiRequest } from './client';
import type { InvitePreviewView, InviteView, MemberRole } from './types';

export const invites = {
  preview: (token: string) =>
    apiRequest<InvitePreviewView>(`/api/invites/${encodeURIComponent(token)}`),
  accept: (token: string) =>
    apiRequest<void>(`/api/invites/${encodeURIComponent(token)}/accept`, { method: 'POST' }),
  list: (organizationId: string) =>
    apiRequest<InviteView[]>(`/api/orgs/${organizationId}/invites`),
  create: (organizationId: string, email: string, role: MemberRole) =>
    apiRequest<InviteView>(`/api/orgs/${organizationId}/invites`, {
      method: 'POST',
      body: { email, role },
    }),
  revoke: (organizationId: string, inviteId: string) =>
    apiRequest<void>(`/api/orgs/${organizationId}/invites/${inviteId}`, { method: 'DELETE' }),
};
